module.exports = __webpack_public_path__ + "img/mobile.8674dd02.png";